module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "centered": "",
      "id": "vote-modify",
      "title": "票数编辑",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function(ref) {
        var cancel = ref.cancel;

        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": _vm.modifyVote
          }
        }, [_vm._v("\n      提交\n    ")])]
      }
    }]),
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("当前票数:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_vm._v(_vm._s(_vm.info.curVotes))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("增减票数:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": _vm.min
    },
    model: {
      value: (_vm.modifyVotes),
      callback: function($$v) {
        _vm.modifyVotes = $$v
      },
      expression: "modifyVotes"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5d36e67b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vote/VoteItemVotesModify.vue
// module id = pFJi
// module chunks = 4